// Tutorial: convite (depois do cadastro ou pelo menu) e entrada na partida guiada.
import { api, errorMessage } from "../api";
import { joinMatch, setCurrentRoom } from "../net";
import { navigate, type View } from "../router";
import { currentUser, setUser } from "../session";
import { GameStore, setGameStore } from "../game/store";
import { loadSprites, spriteHtml } from "../sprites";
import { esc, screen } from "../ui";
import { num, t } from "../i18n";
import { PDX } from "./market";

const TUTORIAL_REWARD = 300;

export const tutorialView: View = (root, { query }) => {
  const u = currentUser()!;
  const fresh = query.get("novo") === "1";
  root.innerHTML = screen(t("tut.offerTitle"), fresh ? null : "/menu", `
    <section class="bw-panel bw-stack tutorial-offer">
      <div class="tutorial-oak" data-oak></div>
      ${fresh ? `<div class="bw-alert bw-alert--ok">${t("menu.welcome", { name: esc(u.nickname) })}</div>` : ""}
      <p>${t("tut.offer", { n: u.tutorialDone ? "0" : `${PDX} ${num(TUTORIAL_REWARD)}` })}</p>
      <div data-alert hidden></div>
      <button class="bw-btn bw-btn--green" data-start>🎓 ${t("tut.start")}</button>
      <button class="bw-btn" data-skip>${t("tut.skip")}</button>
    </section>`);
  void loadSprites().then(() => (root.querySelector("[data-oak]")!.innerHTML = spriteHtml(25, 96)));
  const alert = root.querySelector<HTMLElement>("[data-alert]")!;

  root.querySelector("[data-start]")!.addEventListener("click", async (e) => {
    const btn = e.currentTarget as HTMLButtonElement;
    btn.setAttribute("aria-busy", "true");
    try {
      const room = await joinMatch("tutorial");
      setCurrentRoom(room);
      setGameStore(new GameStore(room));
      navigate("/fila");
    } catch (err) {
      alert.className = "bw-alert bw-alert--error";
      alert.textContent = errorMessage(err);
      alert.hidden = false;
    } finally {
      btn.removeAttribute("aria-busy");
    }
  });
  root.querySelector("[data-skip]")!.addEventListener("click", async () => {
    if (!u.tutorialDone) {
      await api.skipTutorial().catch(() => undefined);
      setUser({ ...currentUser()!, tutorialDone: true });
    }
    navigate(fresh ? "/menu?bemvindo=1" : "/menu");
  });
};
